/**
 * Returns the complete api token state
 *
 * @param {object} state - Current state
 * @returns {object} - The entire api token state
 */
export const getApiTokenState = (state) => state.apitokens;

export default getApiTokenState;
